import React from "react";
import { Col, Row, Image, Button } from "react-bootstrap";
import CaseBidLogo from "../../../assets/images/casebid.png";
import ReportIllustraction from "../../../assets/images/report-illustration.svg";
import InsuranceLogo from "../../../assets/images/insurance-logos.svg";
import "./index.scss";

const MobileAssessment = ({
  isInsurance = false,
  isMobile = false,
  scheduleInspectionCalendly,
}) => {
  return (
    <>
      <div>
        <span className="details assessmentDetails">
          {isInsurance ? (
            <>Curious to see if your insurance will cover a new roof?</>
          ) : (
            <>Ready to explore your options for a brand new roof?</>
          )}
        </span>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
          }}
        >
          <span className="text-muted mt-3">
            Work with us to customize and install your beatiful new roof
          </span>
          <div style={{ width: "50%", textAlign: "end" }}>
            {!isInsurance ? (
              <Image className="toggle-img" width="100%" src={CaseBidLogo} />
            ) : (
              <>
                <Col>
                  <Image
                    className="toggle-img"
                    width="100%"
                    src={ReportIllustraction}
                  />
                </Col>
                <Col>
                  <Image
                    className="toggle-img"
                    width="100%"
                    src={InsuranceLogo}
                  />
                </Col>
              </>
            )}
          </div>
        </div>
        <Button
          onClick={() => scheduleInspectionCalendly()}
          className=" btn-block report-card__request-quote-consultantion-btn align-left mobileAssementbtn mx-0 mt-4"
        >
          Schedule Assessment
        </Button>
      </div>
    </>
  );
};

export default MobileAssessment;
